import { useEffect, useRef, useState } from 'react';

import { environment } from 'src/environments';
import { graphqlRequest, saveUpdatedHasuraTokenInLs } from 'src/app/graphqlClient';
import { PerformanceQueryString } from '../queries/apiTypes';

export const useInitializeEventService = () => {
    const [isTokenAvailable, setTokenAvailable] = useState(false);

    useEffect(() => {
        async function checkAndUpdateToken() {
            const hasToken = Boolean(localStorage.getItem(environment.P));

            if (!hasToken) {
                await saveUpdatedHasuraTokenInLs();
            }

            setTokenAvailable(Boolean(localStorage.getItem(environment.P)));
        }
        const isValidatedUser = Boolean(localStorage.getItem('token'));

        if (isValidatedUser) {
            checkAndUpdateToken();
        }
    }, []);

    return { isTokenAvailable };
};

export const useIntervalForPerformance = () => {
    const timerId = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const intervalId = setInterval(bulkPushEvent, 900000);
        timerId.current = intervalId;

        return () => {
            if (timerId.current) {
                clearInterval(timerId.current);
            }
        };
    }, []);

    const bulkPushEvent = () => {
        const apiList = localStorage.getItem('fe_event_service_performance_api_list_v2');
        if (apiList) {
            localStorage.removeItem('fe_event_service_performance_api_list_v2');
            const jsonString = JSON.parse(apiList);

            const insertMutationString = `mutation ($objects: [app_performance_v2_insert_input!]!) {
                events_db{
                insert_app_performance_v2(objects: $objects) {
                  affected_rows
                }}
              }`;
            graphqlRequest({ document: insertMutationString, variables: { objects: jsonString } });
        }
        // To handle old format of api performance list stored in local storage
        // can be removed after two releases
        const oldApiList = localStorage.getItem('fe_event_service_performance_api_list');
        if (oldApiList) {
            localStorage.removeItem('fe_event_service_performance_api_list');
            const jsonString =
                '[' +
                JSON.parse(oldApiList)
                    .map((obj: PerformanceQueryString) => {
                        return (
                            '{' +
                            Object.entries(obj)
                                .map(([key, value]) => key + ':' + value)
                                .join(',') +
                            '}'
                        );
                    })
                    .join(',') +
                ']';

            const insertMutationString = `mutation {
                events_db{
                insert_app_performance_v2(objects: ${jsonString}) {
                  affected_rows
                }}
              }`;
            graphqlRequest({ document: insertMutationString });
        }
    };
};
